import { PageShell } from '@/components/layout/PageShell'
import { AudioSectionConnected } from '@/features/settings/connected'

export default function AdminAudioPage() {
  return (
    <PageShell>
      <div className="mx-auto max-w-3xl pt-4 md:pt-6">
        <AudioSectionConnected />
      </div>
    </PageShell>
  )
}
